import React from 'react'
import { Chart } from 'react-google-charts'

class EvenimentsTimeline extends React.Component {
    state = {
        options: {
            timeline: {
                rowLabelStyle: {
                    fontName: 'Roboto',
                    fontSize: 16
                },
                colorByRowLabel: true
            }
        }
    }

    get filterResults() {
        return this.props.eveniments
    }

    get mapStateToCols() {
        let cols = [{  
            id: 'Artist Name',
            type: 'string'
        },{  
            id: 'Location Name',
            type: 'string'
        },{  
            id: 'Start Date',
            type: 'date'
        },{  
            id: 'End Date',
            type: 'date'
        }]

        return cols
    }

    get mapStateToRows() {
        let rows = []

        this.filterResults.map(item => {
            let artist = this.props.artists.find(artistI => artistI.id === item.artistId)
            let place = this.props.places.find(placeI => placeI.id === item.placeId)

            rows.push([
                artist ? artist.name : '',
                place ? place.name : '',
                new Date(item.startdate),
                new Date(item.enddate)
            ])

            return null
        })

        return rows
    }

    render() {
        return (
            this.mapStateToRows.length > 0 &&
                <Chart
                    chartType="Timeline"
                    columns={this.mapStateToCols}
                    rows={this.mapStateToRows}
                    options={this.state.options}
                    graph_id="Timeline"
                    width="100%"
                    height="600px" />
            
        )
    }
}

export default EvenimentsTimeline


// WEBPACK FOOTER //
// ./src/components/eveniments/EvenimentsTimeline.js